<style>
#servitudeChangesModal .v--modal-box.v--modal {
  min-height: 450px !important;
  min-width: 550px !important;
}
</style>

<template>
  <Modal
    modalName="servitudeChangesModal"
    title="Lista zmian w służebnościach"
    :buttons="[]"
    @closed="closed()"
  >
    <div v-if="results && results.features && results.features.length > 0">
      <v-subheader v-if="results">Analiza służebności - {{results[0].id}}</v-subheader>
      <div
        v-for="(result,index) in results"
        :key="index"
      >
        <v-layout xs12>
          <v-flex>
            <v-subheader class="font--primary">Działka {{result.properties.parcel}}</v-subheader>
          </v-flex>
          <v-flex xs10>
            <span class="group">
              <v-icon
                small
                class="btn__subheader"
                title="Przybliż do obszaru działki"
                @click="zoomToArea(result)"
              >
                fas fa-search-plus
              </v-icon>
              <v-icon
                small
                class="btn__subheader"
                title="Pokaż kartę służebności"
                @click="showServitudeCard(result)"
              >
                fas fa-info-circle
              </v-icon>
              <v-icon
                small
                class="btn__subheader"
                title="Zapisz zmiany w służebności"
                @click="saveServitude(result)"
              >
                check
              </v-icon>
            </span>
          </v-flex>
        </v-layout>
        <v-layout>
          <v-list style="width: 100%">
            <v-list-tile
              class="list--el"
              v-for="(change,indexChange) in Object.keys(result.properties.changes)"
              :key="indexChange"
            >
              <v-list-tile-content>
                <v-list-tile-title>
                  <span>
                    {{dict[change]}} - Wartość aktualna - {{result.properties[change]}} -> Wynik analizy - {{result.properties.changes[change]}}
                  </span>

                </v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
          </v-list>
        </v-layout>
      </div>
    </div>
    <div v-else>
      Brak zmian w służebnościach
    </div>
  </Modal>
</template>

<script>
import Modal from '../../../shared/Modal';

export default {
  components: {
    Modal
  },
  data: () => ({
    dict: {
      area: "Powierzchnia",
      waters_length: "Długość przewodów wodociągowych",
      sewers_length: "Długość przewodów kanalizacyjnych"
    }
  }),
  computed: {
    results() {
      return this.$store.getters.getAnalysisResult.features
    },
    activeModals() {
      return this.$store.getters.getModalsList;
    }
  },
  methods: {
    show(title) {
      if(this.activeModals.indexOf(title) == -1) {
        this.$store.commit("addModal", title);
        this.$modal.show(title);
      }
    },
    zoomToArea(result) {
      // this.$root.$emit("zoomToArea", result.properties.parcel_geom.coordinates);
      this.$root.$emit("zoomToAreaReproject",
        result.properties.parcel_geom.coordinates,
        this.$store.getters.getSrid,
        "EPSG:2180"
      );
    },
    saveServitude(result) {
      let payload = {
        oid: result.id
      }
      const self = this;
      this.$emit("confDialogOpened", true);
      self.$modal.show("dialog", {
        title: "Akceptowanie zmian w służebnościach",
        text: `Czy na pewno chcesz zatwierdzić zmiany dla działki ${result.properties.parcel}?`,
        buttons: [
          {
            title: "NIE",
            handler: () => {
              this.$emit("confDialogOpened", false);
              self.$modal.hide("dialog");
              return;
            }
          },
          {
            title: "TAK",
            default: true,
            handler: () => {
              self.$store.dispatch("saveAnalysisResult", payload).then(success => {
                if(success) {
                  this.$root.$emit(
                    "showSnackbar",
                    "success",
                    "Pomyślnie zapisano wynik analizy"
                  );
                }
                else {
                  this.$root.$emit(
                    "showSnackbar",
                    "red",
                    "Podczas zapisywania wyniku analizy wystąpił błąd"
                  );
                }
              })
              this.$emit("confDialogOpened", false);
              self.$modal.hide("dialog");
            }
          }
        ]
      });
    },
    showServitudeCard(result) {
      let payload = {
        object_type: "transmission_easement",
        object_id: result.id,
        limit: 5
      };
      this.$store.dispatch("getServitude", payload).then(success => {
        if(success) {
          this.$store
            .dispatch("getFeatureEvents", payload)
            .then(success => {
              if(success) {
                this.show(
                  "servitudeCardModal"
                );
              }
            })
        } else {
          this.$root.$emit(
            "showSnackbar",
            "red",
            "Podczas pobierania wyniku analizy wystąpił błąd"
          );
        }
      })
    },
    closed() {
      this.$root.$emit("setSwitchFalse");
      this.$root.$emit("toggleServitudesLayer", false)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/viewer/servitude/modals/ServitudeChanges.vue